module.exports = __webpack_public_path__ + "img/fire_alarm.f19905bf.webp";